import { render } from "./StudentGradeManeuverComponent.vue?vue&type=template&id=45342ac5&ts=true"
import script from "./StudentGradeManeuverComponent.vue?vue&type=script&lang=ts"
export * from "./StudentGradeManeuverComponent.vue?vue&type=script&lang=ts"

import "./StudentGradeManeuverComponent.vue?vue&type=style&index=0&id=45342ac5&lang=postcss"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__